import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { fetchChat } from '../shared/api/chat';
import { ChatWithSocket } from '../widgets/chat/ChatSocket';
import { ChatMessage } from '../widgets/chat/ChatUI';
import ProjectSessionList from '../widgets/chat/ProjectSessionList';

interface Chat {
  messages?: ChatMessage[];
  metadata?: {
    selectedProject?: {
      location?: {
        projectKey: string;
      };
      id: string;
    };
    chat_title: string;
  };
}

const ChatListPage: React.FC = () => {
  return (
    <div className="min-h-full bg-base-200">
      <div className="p-4 space-y-4">
        <div>
          <div className="text-2xl font-semibold">Chat</div>
          <div className="text-sm opacity-70">General AI conversations, or scoped to a specific project.</div>
        </div>
        <ProjectSessionList />
      </div>
    </div>
  );
};

const ChatPage: React.FC = () => {
  const { chatId } = useParams();
  const [chatMessages, setChatMessages] = React.useState<ChatMessage[]>([]);
  const [chat, setChat] = useState<Chat>();
  const [chatInitConfig, setChatInitConfig] = useState<{
    initMessage: string;
    selectedProject?: {
      id: string;
      location?: { projectKey: string } | undefined;
    };
    docId?: string;
    filename?: string;
  }>();
  const [isChatLoading, setIsChatLoading] = useState(false);

  useEffect(() => {
    if (chatId) {
      setIsChatLoading(true);
      fetchChat(chatId).then((chat) => {
        setChatMessages(chat.messages || []);
        setChat(chat);

        setIsChatLoading(false);
      });
      const initMessage = sessionStorage.getItem(chatId || '');

      if (initMessage) {
        const parsedInitMessage = JSON.parse(initMessage);
        setChatInitConfig(parsedInitMessage);
        sessionStorage.removeItem(chatId || '');
      }
      return;
    }
  }, [chatId]);

  if (!chatId) {
    return <ChatListPage />;
  }

  return (
    <div className="min-h-full">
      {isChatLoading && (
        <div className="flex items-center justify-center h-screen">
          <div className="loader"></div>
        </div>
      )}
      {!isChatLoading && !chat && (
        <div className="flex items-center justify-center h-screen">
          <div className="text-2xl">Chat not found</div>
        </div>
      )}
      {!isChatLoading && chat && (
        <ChatWithSocket
          chatInitConfig={chatInitConfig}
          chatId={chatId}
          projectKey={chat?.metadata?.selectedProject?.location?.projectKey}
          title={chat?.metadata?.chat_title}
          boardId={chat?.metadata?.selectedProject?.id}
          history={chatMessages}
        />
      )}
    </div>
  );
};

export default ChatPage;
